export default {
  header: {
    title: '资金记录'
  },
  title: '交易账号',
  deposit: {
    orderId: '订单号',
    createdDate: '申请时间',
    tradeAccountNumber: '登录账号',
    amount: '存款金额',
    realAmount: '到账金额',
    exchangeAmount: '换汇后入账金额',
    status: '状态',
    remark: '备注',
    noDeposit: '无存款记录',
    fundBankType: '入金方式'
  },
  withdrawal: {
    orderId: '订单号',
    createdDate: '申请时间',
    tradeAccountNumber: '登录账号',
    amount: '取款金额',
    status: '状态',
    remark: '备注',
    noWithdrawal: '无取款记录',
    fundBankType: '出金方式'
  },
  transfer: {
    orderId: '订单号',
    createdDate: '申请时间',
    toTradeAccountNumber: '转入账户',
    fromTradeAccountNumber: '转出账户',
    amount: '申请金额',
    status: '状态',
    realAmount: '实际转账金额',
    remark: '备注',
    noFund: '无内部转账记录'
  },
  status: {
    completed: '完成',
    processing: '处理中',
    failure: '失败',
    submitted: '已提交',
    checking: '已确认',
    canceled: '已撤销',
    verified: '已提交',
    withdrawalcompleted: '已处理',
    withdrawn: '被退回'
  },
  errorTips: {
    unprocessedData: '还有未处理的提交'
  },
  export: '导出', // 补充
  chooseTime: '请选择时间',
  exchange: {
    orderId: '订单号',
    createdDate: '申请时间',
    tradeAccountNumber: '登录账号',
    amount: '申请换汇金额',
    lockWay: '锁定方向',
    realAmount: '实际换汇金额',
    realExchangeRate: '实际汇率',
    status: '状态',
    remark: '备注',
    noFund: '无换汇记录'
  }
}
